const cleanEmail = (email) => email && email.toLowerCase().trim();
export default cleanEmail;
